import styles from './styles.module.css';

export default function DescriptionLcaTool({ dict }) {
    // Извлекаем из словаря нужные поля
    const {
        description_lca_tool_1,
        description_lca_tool_2
    } = dict.discover;

    return (
        <section className={styles.desrription_lca_tool}>
            <p>{description_lca_tool_1}</p>
            <p>{description_lca_tool_2}</p>
        </section>
    );
}
